import styled from "styled-components";

export const Container = styled.div`
  & {
    width: 100%;
    height: 100vh;
    background-color: ${(props) => props.theme.colors.white};
    display: grid;
    grid-template-columns: 220px 3fr;
    grid-template-rows: 75px 0px 1fr;
    grid-row-gap: 0px;
  }
  header {
    button {
      font-size: ${(p) => p.theme.spacing.spacing_05};
      text-transform: uppercase;
      width: ${(p) => p.theme.spacing.spacing_11};
      height: ${props => props.theme.spacing.spacing_09};
      background-color: ${(props) => props.theme.colors.secondary};
    }
  }

  h2 {
    font-size: 20px;
    font-weight: 400;
  }

  a, li {
    text-decoration:none;
    display:block;
    transition: all 0.2s ;
  }
  
  aside {
    display: flex;
    justify-content: start;
    flex-direction: column;
    overflow-y: auto;
    grid-column: 1/2;
    grid-row: 3/4;
    background-color: ${(props) => props.theme.colors.primary_light};
    a {
      position: relative;
      text-decoration:none;
      display:block;
      color: ${(props) => props.theme.colors.black};
      padding-top: 1.25rem;
      padding-bottom: ${(props) => props.theme.spacing.spacing_04};
    }
    a:hover {
      background-color: ${(props) => props.theme.colors.primary}
    }
  }
  
  .subMenu{
    cursor: pointer;
    position: relative;
    text-decoration:none;
    display:block;
    color: ${(props) => props.theme.colors.black};
    padding-bottom: ${(props) => props.theme.spacing.spacing_04};
    
    a{
      padding-left:15px;
      background-color: ${(props) => props.theme.colors.gray};
      color: white;
    }
    a:hover {
      background-color: ${(props) => props.theme.colors.gray_dark_01};
      color: ${(props) => props.theme.colors.black}
    }
    .active-link{
      background-color: ${(props) => props.theme.colors.secondary};
    }
    .active-link:hover{
      background-color: ${(props) => props.theme.colors.secondary}
    }
    
  }

  a:not(:active) ul {
    margin:0;
  }

  .active-link {
      background-color: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.white};
      text-decoration:none;
      display:block;
    
  }
  .active-link:hover {
      background-color: ${(props) => props.theme.colors.secondary}
  }      
  .icon {
    margin-left: ${(props) => props.theme.spacing.spacing_03};
    margin-right: ${(props) => props.theme.spacing.spacing_05}; //10px;
  }
  .iconDown{
    position:absolute;
	  right: ${(props) => props.theme.spacing.spacing_03};
  }
  .logo {
    grid-column: 1/2;
    grid-row: 1/3;
    img{
      width: 100%;
      height: auto;
      max-height: 100%;
      min-height: 50%;
    }
  }
`;
